/**
 * user模块接口列表
 */
import requestByBasic from '@/request/request.basic';
import config from '@/config';

const errorLog = {
	/**
	 * 上传错误日志
	 */
	saveErrorLog(data) {
		return requestByBasic.post(`${config.api.xbull}/log/error`, data);
	},
	/**
	 * 错误api
	 */
	sendWrongRequest() {
		return requestByBasic.get(
			'http://ps.10niu.cn/PS-develop/Wechat/School/getSchoolIntroduction'
		);
	}
};

export default errorLog;
